import React, {Component} from 'react';
import Masonry from 'masonry-layout';
import {columnWidth, animation} from '../settings';

const options = {
  resize: false,
  columnWidth: columnWidth,
  itemSelector: '.Grid-item',
  transitionDuration: animation.time,
  stagger: 10,
  gutter: 0
};

class MasonryWrapper extends Component{

  constructor(props){
    super(props);
    this.grid = React.createRef();
  }

  componentDidMount(){
    this.msnry = new Masonry( this.grid.current,options);
  }

  componentDidUpdate() {
    this.props.scrollToProject();
    this.msnry.layout();
  }

  render(){
    return(
      <div ref={this.grid} options={options} className={'Grid'}>
        {this.props.children}
      </div>
    )
  }

}

export default MasonryWrapper;


// WEBPACK FOOTER //
// ./src/components/MasonryWrapper.js